import { render, staticRenderFns } from "./AddItemPage.vue?vue&type=template&id=416d4cd5&scoped=true&"
import script from "./AddItemPage.vue?vue&type=script&lang=js&"
export * from "./AddItemPage.vue?vue&type=script&lang=js&"
import style0 from "./AddItemPage.vue?vue&type=style&index=0&id=416d4cd5&lang=scss&scoped=true&"
import style1 from "./AddItemPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d4cd5",
  null
  
)

export default component.exports